"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrganizationButton = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _Group = _interopRequireDefault(require("@material-ui/icons/Group"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _Button = _interopRequireDefault(require("../../../Button"));

var OrganizationButton = function OrganizationButton(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      id = _ref.id,
      showOrgSwitcher = _ref.showOrgSwitcher,
      onClick = _ref.onClick,
      currentOrg = _ref.currentOrg,
      open = _ref.open;
  return /*#__PURE__*/_react.default.createElement("button", {
    id: id,
    className: (0, _classnames.default)("prmbl-OrganizationButton", className, classes.root),
    onClick: showOrgSwitcher ? onClick : undefined
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("prmbl-OrganizationListIcon", classes.icon)
  }, /*#__PURE__*/_react.default.createElement(_Group.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)("prmbl-OrganizationSelected", classes.selected, (0, _defineProperty2.default)({}, classes.selectedArrow, showOrgSwitcher))
  }, currentOrg), showOrgSwitcher && /*#__PURE__*/_react.default.createElement(_Button.default, {
    component: "div",
    "data-testid": "orgSwitcher",
    title: open ? "Hide available organizations" : "Show available organizations",
    type: "icon",
    color: "inherit",
    "aria-haspopup": "menu",
    onClick: onClick,
    className: (0, _classnames.default)("prmbl-OrganizationListToggle", classes.toggle, classes.arrowContainer, (0, _defineProperty2.default)({}, classes.arrowContainerOpen, !open))
  }, /*#__PURE__*/_react.default.createElement(_ExpandMore.default, null)));
};

exports.OrganizationButton = OrganizationButton;
OrganizationButton.defaultProps = {
  showOrgSwitcher: false
};

var _default = (0, _styles2.withStyles)(_styles.styles)(OrganizationButton);

exports.default = _default;